/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_TimeInputs */

const en_consult_time = /** @type {(inputs: Consult_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About 2 minutes`)
};

const id_consult_time = /** @type {(inputs: Consult_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekitar 2 menit`)
};

/**
* | output |
* | --- |
* | "About 2 minutes" |
*
* @param {Consult_TimeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_time = /** @type {((inputs?: Consult_TimeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_TimeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_time(inputs)
	return en_consult_time(inputs)
});